export default __webpack_public_path__ + "static/media/samyukthar.150c2707.jpg";